import { render, staticRenderFns } from "./AvisoCookies.vue?vue&type=template&id=16cc0a33&scoped=true&"
import script from "./AvisoCookies.vue?vue&type=script&lang=js&"
export * from "./AvisoCookies.vue?vue&type=script&lang=js&"
import style0 from "./AvisoCookies.vue?vue&type=style&index=0&id=16cc0a33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc0a33",
  null
  
)

export default component.exports